import Image from 'next/image';
import { type ReactElement } from 'react';

import Button from '@/components/DesignLibrary/Button';
import Spacer from '@/components/Spacer';

import s from './CreditReportModal.module.scss';

type RequestIdentityVerificationProps = {
  mobile: string;
  handleSendVerificationLink: () => void;
};

const RequestIdentityVerification = ({
  mobile,
  handleSendVerificationLink,
}: RequestIdentityVerificationProps): ReactElement => {
  const lastFourMobileDigits = mobile.slice(-4);

  return (
    <div className={s.identityVerification}>
      <Image src='/images/credit-report/fingerprint.png' alt='' width={168} height={168} />
      <h2 className='heading-sm'>Verify Your Identity</h2>
      <Spacer size={1} />
      <p className={s.identityVerificationContent}>
        In cooperation with StitchCredit and Equifax, we will attempt to confirm your identity by sending a secure
        mobile link via text message to your mobile phone number ending
        <span className={s.identityVerificationMobileNumber}>&nbsp;{lastFourMobileDigits}</span>.
      </p>
      <p className={s.identityVerificationContent}>
        To continue, open this link on your mobile phone and wait for verification to complete. Message and data rates
        may apply.
      </p>
      <Spacer size={1} />
      <Button
        variant='primary'
        size='md'
        fullWidth={true}
        onClick={handleSendVerificationLink}
        className={s.noodleColor}
      >
        Send Link
      </Button>
    </div>
  );
};

export default RequestIdentityVerification;
